import { createLogic } from "redux-logic";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

import * as ActionTypes from "../../actions/actionTypes";
import * as ControlPanelActions from "../../actions/controlPanelActions";
import * as OAuthActions from "../../actions/oauthActions";
import * as constants from "../../constants";

const saveOAuthCodeLogic = createLogic({
	type: ActionTypes.SAVE_AUTH_CODE,
	// eslint-disable-next-line no-unused-vars
	process({ action }, dispatch, done) {
		dispatch(ControlPanelActions.showLoading());
		firebase
			.auth()
			.currentUser.getIdToken()
			.then(token => {
				let api = axios.create({
					baseURL: constants.BASE_API_URL,
					headers: { Authorization: "Bearer " + token },
				});
				const { payload: authData } = action;
				api.post("/oauth/2.0", authData)
					.then(res => {
						dispatch(OAuthActions.saveAuthCodeSuccess(res.data));
					})
					.catch(error => {
						dispatch(ControlPanelActions.displayError(error.message));
						dispatch(OAuthActions.saveAuthCodeFailure(error.response.data.Message));
					})
					.finally(() => {
						dispatch(ControlPanelActions.hideLoading());
						done();
					});
			});
	},
});

export default [saveOAuthCodeLogic];
